import script from "./FileSelectorTextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileSelectorTextArea.vue?vue&type=script&setup=true&lang=ts"

import "./FileSelectorTextArea.vue?vue&type=style&index=0&id=7e182d7d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e182d7d"]])

export default __exports__